/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as BriefRouteImport } from "./routes/brief";
import { Route as ClaimsRouteImport } from "./routes/claims";
import { Route as ClosedLoopRouteImport } from "./routes/closed-loop";
import { Route as ComplianceRouteImport } from "./routes/compliance";
import { Route as DashboardRouteImport } from "./routes/dashboard";
import { Route as DataConfidenceRouteImport } from "./routes/data-confidence";
import { Route as DemoRouteImport } from "./routes/demo";
import { Route as EffectivenessPreventionRouteImport } from "./routes/effectiveness-prevention";
import { Route as ExecutiveRouteImport } from "./routes/executive";
import { Route as FinancialRouteImport } from "./routes/financial";
import { Route as FinancialIntelligenceRouteImport } from "./routes/financial-intelligence";
import { Route as PortfolioRouteImport } from "./routes/portfolio";
import { Route as PreventionRouteImport } from "./routes/prevention";
import { Route as ProblemRecordsRouteImport } from "./routes/problem-records";
import { Route as ProfileRouteImport } from "./routes/profile";
import { Route as ProgramsRouteImport } from "./routes/programs";
import { Route as RecallSafetyRouteImport } from "./routes/recall-safety";
import { Route as SafetyRouteImport } from "./routes/safety";
import { Route as SignalsRouteImport } from "./routes/signals";
import { Route as SuppliersRouteImport } from "./routes/suppliers";
import { Route as Top5RouteImport } from "./routes/top5";
import { Route as DemoIndexRouteImport } from "./routes/demo/index";
import { Route as DemoBriefRouteImport } from "./routes/demo/brief";
import { Route as DemoClaimsRouteImport } from "./routes/demo/claims";
import { Route as DemoClosedLoopRouteImport } from "./routes/demo/closed-loop";
import { Route as DemoComplianceRouteImport } from "./routes/demo/compliance";
import { Route as DemoDashboardRouteImport } from "./routes/demo/dashboard";
import { Route as DemoExecutiveRouteImport } from "./routes/demo/executive";
import { Route as DemoFinancialRouteImport } from "./routes/demo/financial";
import { Route as DemoOpenProblemRecordsRouteImport } from "./routes/demo/open-problem-records";
import { Route as DemoPortfolioRouteImport } from "./routes/demo/portfolio";
import { Route as DemoPreventionRouteImport } from "./routes/demo/prevention";
import { Route as DemoProblemRecordsRouteImport } from "./routes/demo/problem-records";
import { Route as DemoProgramsRouteImport } from "./routes/demo/programs";
import { Route as DemoSafetyRouteImport } from "./routes/demo/safety";
import { Route as DemoSignalsRouteImport } from "./routes/demo/signals";
import { Route as DemoSuppliersRouteImport } from "./routes/demo/suppliers";
import { Route as DemoTop5RouteImport } from "./routes/demo/top5";
import { Route as DemoUsersRouteImport } from "./routes/demo/users";
import { Route as ProblemRecordIdRouteImport } from "./routes/problem-record.$id";
import { Route as DemoProblemRecordIdRouteImport } from "./routes/demo/problem-record.$id";
import { Route as DemoSignalIdRouteImport } from "./routes/demo/signal.$id";

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const BriefRoute = BriefRouteImport.update({
  id: "/brief",
  path: "/brief",
  getParentRoute: () => rootRouteImport,
} as any);
const ClaimsRoute = ClaimsRouteImport.update({
  id: "/claims",
  path: "/claims",
  getParentRoute: () => rootRouteImport,
} as any);
const ClosedLoopRoute = ClosedLoopRouteImport.update({
  id: "/closed-loop",
  path: "/closed-loop",
  getParentRoute: () => rootRouteImport,
} as any);
const ComplianceRoute = ComplianceRouteImport.update({
  id: "/compliance",
  path: "/compliance",
  getParentRoute: () => rootRouteImport,
} as any);
const DashboardRoute = DashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => rootRouteImport,
} as any);
const DataConfidenceRoute = DataConfidenceRouteImport.update({
  id: "/data-confidence",
  path: "/data-confidence",
  getParentRoute: () => rootRouteImport,
} as any);
const DemoRoute = DemoRouteImport.update({
  id: "/demo",
  path: "/demo",
  getParentRoute: () => rootRouteImport,
} as any);
const EffectivenessPreventionRoute = EffectivenessPreventionRouteImport.update({
  id: "/effectiveness-prevention",
  path: "/effectiveness-prevention",
  getParentRoute: () => rootRouteImport,
} as any);
const ExecutiveRoute = ExecutiveRouteImport.update({
  id: "/executive",
  path: "/executive",
  getParentRoute: () => rootRouteImport,
} as any);
const FinancialRoute = FinancialRouteImport.update({
  id: "/financial",
  path: "/financial",
  getParentRoute: () => rootRouteImport,
} as any);
const FinancialIntelligenceRoute = FinancialIntelligenceRouteImport.update({
  id: "/financial-intelligence",
  path: "/financial-intelligence",
  getParentRoute: () => rootRouteImport,
} as any);
const PortfolioRoute = PortfolioRouteImport.update({
  id: "/portfolio",
  path: "/portfolio",
  getParentRoute: () => rootRouteImport,
} as any);
const PreventionRoute = PreventionRouteImport.update({
  id: "/prevention",
  path: "/prevention",
  getParentRoute: () => rootRouteImport,
} as any);
const ProblemRecordsRoute = ProblemRecordsRouteImport.update({
  id: "/problem-records",
  path: "/problem-records",
  getParentRoute: () => rootRouteImport,
} as any);
const ProfileRoute = ProfileRouteImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => rootRouteImport,
} as any);
const ProgramsRoute = ProgramsRouteImport.update({
  id: "/programs",
  path: "/programs",
  getParentRoute: () => rootRouteImport,
} as any);
const RecallSafetyRoute = RecallSafetyRouteImport.update({
  id: "/recall-safety",
  path: "/recall-safety",
  getParentRoute: () => rootRouteImport,
} as any);
const SafetyRoute = SafetyRouteImport.update({
  id: "/safety",
  path: "/safety",
  getParentRoute: () => rootRouteImport,
} as any);
const SignalsRoute = SignalsRouteImport.update({
  id: "/signals",
  path: "/signals",
  getParentRoute: () => rootRouteImport,
} as any);
const SuppliersRoute = SuppliersRouteImport.update({
  id: "/suppliers",
  path: "/suppliers",
  getParentRoute: () => rootRouteImport,
} as any);
const Top5Route = Top5RouteImport.update({
  id: "/top5",
  path: "/top5",
  getParentRoute: () => rootRouteImport,
} as any);
const DemoIndexRoute = DemoIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => DemoRoute,
} as any);
const DemoBriefRoute = DemoBriefRouteImport.update({
  id: "/brief",
  path: "/brief",
  getParentRoute: () => DemoRoute,
} as any);
const DemoClaimsRoute = DemoClaimsRouteImport.update({
  id: "/claims",
  path: "/claims",
  getParentRoute: () => DemoRoute,
} as any);
const DemoClosedLoopRoute = DemoClosedLoopRouteImport.update({
  id: "/closed-loop",
  path: "/closed-loop",
  getParentRoute: () => DemoRoute,
} as any);
const DemoComplianceRoute = DemoComplianceRouteImport.update({
  id: "/compliance",
  path: "/compliance",
  getParentRoute: () => DemoRoute,
} as any);
const DemoDashboardRoute = DemoDashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => DemoRoute,
} as any);
const DemoExecutiveRoute = DemoExecutiveRouteImport.update({
  id: "/executive",
  path: "/executive",
  getParentRoute: () => DemoRoute,
} as any);
const DemoFinancialRoute = DemoFinancialRouteImport.update({
  id: "/financial",
  path: "/financial",
  getParentRoute: () => DemoRoute,
} as any);
const DemoOpenProblemRecordsRoute = DemoOpenProblemRecordsRouteImport.update({
  id: "/open-problem-records",
  path: "/open-problem-records",
  getParentRoute: () => DemoRoute,
} as any);
const DemoPortfolioRoute = DemoPortfolioRouteImport.update({
  id: "/portfolio",
  path: "/portfolio",
  getParentRoute: () => DemoRoute,
} as any);
const DemoPreventionRoute = DemoPreventionRouteImport.update({
  id: "/prevention",
  path: "/prevention",
  getParentRoute: () => DemoRoute,
} as any);
const DemoProblemRecordsRoute = DemoProblemRecordsRouteImport.update({
  id: "/problem-records",
  path: "/problem-records",
  getParentRoute: () => DemoRoute,
} as any);
const DemoProgramsRoute = DemoProgramsRouteImport.update({
  id: "/programs",
  path: "/programs",
  getParentRoute: () => DemoRoute,
} as any);
const DemoSafetyRoute = DemoSafetyRouteImport.update({
  id: "/safety",
  path: "/safety",
  getParentRoute: () => DemoRoute,
} as any);
const DemoSignalsRoute = DemoSignalsRouteImport.update({
  id: "/signals",
  path: "/signals",
  getParentRoute: () => DemoRoute,
} as any);
const DemoSuppliersRoute = DemoSuppliersRouteImport.update({
  id: "/suppliers",
  path: "/suppliers",
  getParentRoute: () => DemoRoute,
} as any);
const DemoTop5Route = DemoTop5RouteImport.update({
  id: "/top5",
  path: "/top5",
  getParentRoute: () => DemoRoute,
} as any);
const DemoUsersRoute = DemoUsersRouteImport.update({
  id: "/users",
  path: "/users",
  getParentRoute: () => DemoRoute,
} as any);
const ProblemRecordIdRoute = ProblemRecordIdRouteImport.update({
  id: "/problem-record/$id",
  path: "/problem-record/$id",
  getParentRoute: () => rootRouteImport,
} as any);
const DemoProblemRecordIdRoute = DemoProblemRecordIdRouteImport.update({
  id: "/problem-record/$id",
  path: "/problem-record/$id",
  getParentRoute: () => DemoRoute,
} as any);
const DemoSignalIdRoute = DemoSignalIdRouteImport.update({
  id: "/signal/$id",
  path: "/signal/$id",
  getParentRoute: () => DemoRoute,
} as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/brief": typeof BriefRoute;
  "/claims": typeof ClaimsRoute;
  "/closed-loop": typeof ClosedLoopRoute;
  "/compliance": typeof ComplianceRoute;
  "/dashboard": typeof DashboardRoute;
  "/data-confidence": typeof DataConfidenceRoute;
  "/demo": typeof DemoRouteWithChildren;
  "/effectiveness-prevention": typeof EffectivenessPreventionRoute;
  "/executive": typeof ExecutiveRoute;
  "/financial": typeof FinancialRoute;
  "/financial-intelligence": typeof FinancialIntelligenceRoute;
  "/portfolio": typeof PortfolioRoute;
  "/prevention": typeof PreventionRoute;
  "/problem-records": typeof ProblemRecordsRoute;
  "/profile": typeof ProfileRoute;
  "/programs": typeof ProgramsRoute;
  "/recall-safety": typeof RecallSafetyRoute;
  "/safety": typeof SafetyRoute;
  "/signals": typeof SignalsRoute;
  "/suppliers": typeof SuppliersRoute;
  "/top5": typeof Top5Route;
  "/demo/brief": typeof DemoBriefRoute;
  "/demo/claims": typeof DemoClaimsRoute;
  "/demo/closed-loop": typeof DemoClosedLoopRoute;
  "/demo/compliance": typeof DemoComplianceRoute;
  "/demo/dashboard": typeof DemoDashboardRoute;
  "/demo/executive": typeof DemoExecutiveRoute;
  "/demo/financial": typeof DemoFinancialRoute;
  "/demo/open-problem-records": typeof DemoOpenProblemRecordsRoute;
  "/demo/portfolio": typeof DemoPortfolioRoute;
  "/demo/prevention": typeof DemoPreventionRoute;
  "/demo/problem-records": typeof DemoProblemRecordsRoute;
  "/demo/programs": typeof DemoProgramsRoute;
  "/demo/safety": typeof DemoSafetyRoute;
  "/demo/signals": typeof DemoSignalsRoute;
  "/demo/suppliers": typeof DemoSuppliersRoute;
  "/demo/top5": typeof DemoTop5Route;
  "/demo/users": typeof DemoUsersRoute;
  "/problem-record/$id": typeof ProblemRecordIdRoute;
  "/demo/": typeof DemoIndexRoute;
  "/demo/problem-record/$id": typeof DemoProblemRecordIdRoute;
  "/demo/signal/$id": typeof DemoSignalIdRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/brief": typeof BriefRoute;
  "/claims": typeof ClaimsRoute;
  "/closed-loop": typeof ClosedLoopRoute;
  "/compliance": typeof ComplianceRoute;
  "/dashboard": typeof DashboardRoute;
  "/data-confidence": typeof DataConfidenceRoute;
  "/effectiveness-prevention": typeof EffectivenessPreventionRoute;
  "/executive": typeof ExecutiveRoute;
  "/financial": typeof FinancialRoute;
  "/financial-intelligence": typeof FinancialIntelligenceRoute;
  "/portfolio": typeof PortfolioRoute;
  "/prevention": typeof PreventionRoute;
  "/problem-records": typeof ProblemRecordsRoute;
  "/profile": typeof ProfileRoute;
  "/programs": typeof ProgramsRoute;
  "/recall-safety": typeof RecallSafetyRoute;
  "/safety": typeof SafetyRoute;
  "/signals": typeof SignalsRoute;
  "/suppliers": typeof SuppliersRoute;
  "/top5": typeof Top5Route;
  "/demo/brief": typeof DemoBriefRoute;
  "/demo/claims": typeof DemoClaimsRoute;
  "/demo/closed-loop": typeof DemoClosedLoopRoute;
  "/demo/compliance": typeof DemoComplianceRoute;
  "/demo/dashboard": typeof DemoDashboardRoute;
  "/demo/executive": typeof DemoExecutiveRoute;
  "/demo/financial": typeof DemoFinancialRoute;
  "/demo/open-problem-records": typeof DemoOpenProblemRecordsRoute;
  "/demo/portfolio": typeof DemoPortfolioRoute;
  "/demo/prevention": typeof DemoPreventionRoute;
  "/demo/problem-records": typeof DemoProblemRecordsRoute;
  "/demo/programs": typeof DemoProgramsRoute;
  "/demo/safety": typeof DemoSafetyRoute;
  "/demo/signals": typeof DemoSignalsRoute;
  "/demo/suppliers": typeof DemoSuppliersRoute;
  "/demo/top5": typeof DemoTop5Route;
  "/demo/users": typeof DemoUsersRoute;
  "/problem-record/$id": typeof ProblemRecordIdRoute;
  "/demo": typeof DemoIndexRoute;
  "/demo/problem-record/$id": typeof DemoProblemRecordIdRoute;
  "/demo/signal/$id": typeof DemoSignalIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/brief": typeof BriefRoute;
  "/claims": typeof ClaimsRoute;
  "/closed-loop": typeof ClosedLoopRoute;
  "/compliance": typeof ComplianceRoute;
  "/dashboard": typeof DashboardRoute;
  "/data-confidence": typeof DataConfidenceRoute;
  "/demo": typeof DemoRouteWithChildren;
  "/effectiveness-prevention": typeof EffectivenessPreventionRoute;
  "/executive": typeof ExecutiveRoute;
  "/financial": typeof FinancialRoute;
  "/financial-intelligence": typeof FinancialIntelligenceRoute;
  "/portfolio": typeof PortfolioRoute;
  "/prevention": typeof PreventionRoute;
  "/problem-records": typeof ProblemRecordsRoute;
  "/profile": typeof ProfileRoute;
  "/programs": typeof ProgramsRoute;
  "/recall-safety": typeof RecallSafetyRoute;
  "/safety": typeof SafetyRoute;
  "/signals": typeof SignalsRoute;
  "/suppliers": typeof SuppliersRoute;
  "/top5": typeof Top5Route;
  "/demo/brief": typeof DemoBriefRoute;
  "/demo/claims": typeof DemoClaimsRoute;
  "/demo/closed-loop": typeof DemoClosedLoopRoute;
  "/demo/compliance": typeof DemoComplianceRoute;
  "/demo/dashboard": typeof DemoDashboardRoute;
  "/demo/executive": typeof DemoExecutiveRoute;
  "/demo/financial": typeof DemoFinancialRoute;
  "/demo/open-problem-records": typeof DemoOpenProblemRecordsRoute;
  "/demo/portfolio": typeof DemoPortfolioRoute;
  "/demo/prevention": typeof DemoPreventionRoute;
  "/demo/problem-records": typeof DemoProblemRecordsRoute;
  "/demo/programs": typeof DemoProgramsRoute;
  "/demo/safety": typeof DemoSafetyRoute;
  "/demo/signals": typeof DemoSignalsRoute;
  "/demo/suppliers": typeof DemoSuppliersRoute;
  "/demo/top5": typeof DemoTop5Route;
  "/demo/users": typeof DemoUsersRoute;
  "/problem-record/$id": typeof ProblemRecordIdRoute;
  "/demo/": typeof DemoIndexRoute;
  "/demo/problem-record/$id": typeof DemoProblemRecordIdRoute;
  "/demo/signal/$id": typeof DemoSignalIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/brief"
    | "/claims"
    | "/closed-loop"
    | "/compliance"
    | "/dashboard"
    | "/data-confidence"
    | "/demo"
    | "/effectiveness-prevention"
    | "/executive"
    | "/financial"
    | "/financial-intelligence"
    | "/portfolio"
    | "/prevention"
    | "/problem-records"
    | "/profile"
    | "/programs"
    | "/recall-safety"
    | "/safety"
    | "/signals"
    | "/suppliers"
    | "/top5"
    | "/demo/brief"
    | "/demo/claims"
    | "/demo/closed-loop"
    | "/demo/compliance"
    | "/demo/dashboard"
    | "/demo/executive"
    | "/demo/financial"
    | "/demo/open-problem-records"
    | "/demo/portfolio"
    | "/demo/prevention"
    | "/demo/problem-records"
    | "/demo/programs"
    | "/demo/safety"
    | "/demo/signals"
    | "/demo/suppliers"
    | "/demo/top5"
    | "/demo/users"
    | "/problem-record/$id"
    | "/demo/"
    | "/demo/problem-record/$id"
    | "/demo/signal/$id";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/brief"
    | "/claims"
    | "/closed-loop"
    | "/compliance"
    | "/dashboard"
    | "/data-confidence"
    | "/effectiveness-prevention"
    | "/executive"
    | "/financial"
    | "/financial-intelligence"
    | "/portfolio"
    | "/prevention"
    | "/problem-records"
    | "/profile"
    | "/programs"
    | "/recall-safety"
    | "/safety"
    | "/signals"
    | "/suppliers"
    | "/top5"
    | "/demo/brief"
    | "/demo/claims"
    | "/demo/closed-loop"
    | "/demo/compliance"
    | "/demo/dashboard"
    | "/demo/executive"
    | "/demo/financial"
    | "/demo/open-problem-records"
    | "/demo/portfolio"
    | "/demo/prevention"
    | "/demo/problem-records"
    | "/demo/programs"
    | "/demo/safety"
    | "/demo/signals"
    | "/demo/suppliers"
    | "/demo/top5"
    | "/demo/users"
    | "/problem-record/$id"
    | "/demo"
    | "/demo/problem-record/$id"
    | "/demo/signal/$id";
  id:
    | "__root__"
    | "/"
    | "/brief"
    | "/claims"
    | "/closed-loop"
    | "/compliance"
    | "/dashboard"
    | "/data-confidence"
    | "/demo"
    | "/effectiveness-prevention"
    | "/executive"
    | "/financial"
    | "/financial-intelligence"
    | "/portfolio"
    | "/prevention"
    | "/problem-records"
    | "/profile"
    | "/programs"
    | "/recall-safety"
    | "/safety"
    | "/signals"
    | "/suppliers"
    | "/top5"
    | "/demo/brief"
    | "/demo/claims"
    | "/demo/closed-loop"
    | "/demo/compliance"
    | "/demo/dashboard"
    | "/demo/executive"
    | "/demo/financial"
    | "/demo/open-problem-records"
    | "/demo/portfolio"
    | "/demo/prevention"
    | "/demo/problem-records"
    | "/demo/programs"
    | "/demo/safety"
    | "/demo/signals"
    | "/demo/suppliers"
    | "/demo/top5"
    | "/demo/users"
    | "/problem-record/$id"
    | "/demo/"
    | "/demo/problem-record/$id"
    | "/demo/signal/$id";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  BriefRoute: typeof BriefRoute;
  ClaimsRoute: typeof ClaimsRoute;
  ClosedLoopRoute: typeof ClosedLoopRoute;
  ComplianceRoute: typeof ComplianceRoute;
  DashboardRoute: typeof DashboardRoute;
  DataConfidenceRoute: typeof DataConfidenceRoute;
  DemoRoute: typeof DemoRouteWithChildren;
  EffectivenessPreventionRoute: typeof EffectivenessPreventionRoute;
  ExecutiveRoute: typeof ExecutiveRoute;
  FinancialRoute: typeof FinancialRoute;
  FinancialIntelligenceRoute: typeof FinancialIntelligenceRoute;
  PortfolioRoute: typeof PortfolioRoute;
  PreventionRoute: typeof PreventionRoute;
  ProblemRecordsRoute: typeof ProblemRecordsRoute;
  ProfileRoute: typeof ProfileRoute;
  ProgramsRoute: typeof ProgramsRoute;
  RecallSafetyRoute: typeof RecallSafetyRoute;
  SafetyRoute: typeof SafetyRoute;
  SignalsRoute: typeof SignalsRoute;
  SuppliersRoute: typeof SuppliersRoute;
  Top5Route: typeof Top5Route;
  ProblemRecordIdRoute: typeof ProblemRecordIdRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/brief": {
      id: "/brief";
      path: "/brief";
      fullPath: "/brief";
      preLoaderRoute: typeof BriefRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/claims": {
      id: "/claims";
      path: "/claims";
      fullPath: "/claims";
      preLoaderRoute: typeof ClaimsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/closed-loop": {
      id: "/closed-loop";
      path: "/closed-loop";
      fullPath: "/closed-loop";
      preLoaderRoute: typeof ClosedLoopRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/compliance": {
      id: "/compliance";
      path: "/compliance";
      fullPath: "/compliance";
      preLoaderRoute: typeof ComplianceRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/dashboard": {
      id: "/dashboard";
      path: "/dashboard";
      fullPath: "/dashboard";
      preLoaderRoute: typeof DashboardRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/data-confidence": {
      id: "/data-confidence";
      path: "/data-confidence";
      fullPath: "/data-confidence";
      preLoaderRoute: typeof DataConfidenceRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/demo": {
      id: "/demo";
      path: "/demo";
      fullPath: "/demo";
      preLoaderRoute: typeof DemoRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/effectiveness-prevention": {
      id: "/effectiveness-prevention";
      path: "/effectiveness-prevention";
      fullPath: "/effectiveness-prevention";
      preLoaderRoute: typeof EffectivenessPreventionRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/executive": {
      id: "/executive";
      path: "/executive";
      fullPath: "/executive";
      preLoaderRoute: typeof ExecutiveRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/financial": {
      id: "/financial";
      path: "/financial";
      fullPath: "/financial";
      preLoaderRoute: typeof FinancialRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/financial-intelligence": {
      id: "/financial-intelligence";
      path: "/financial-intelligence";
      fullPath: "/financial-intelligence";
      preLoaderRoute: typeof FinancialIntelligenceRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/portfolio": {
      id: "/portfolio";
      path: "/portfolio";
      fullPath: "/portfolio";
      preLoaderRoute: typeof PortfolioRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/prevention": {
      id: "/prevention";
      path: "/prevention";
      fullPath: "/prevention";
      preLoaderRoute: typeof PreventionRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/problem-records": {
      id: "/problem-records";
      path: "/problem-records";
      fullPath: "/problem-records";
      preLoaderRoute: typeof ProblemRecordsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/profile": {
      id: "/profile";
      path: "/profile";
      fullPath: "/profile";
      preLoaderRoute: typeof ProfileRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/programs": {
      id: "/programs";
      path: "/programs";
      fullPath: "/programs";
      preLoaderRoute: typeof ProgramsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/recall-safety": {
      id: "/recall-safety";
      path: "/recall-safety";
      fullPath: "/recall-safety";
      preLoaderRoute: typeof RecallSafetyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/safety": {
      id: "/safety";
      path: "/safety";
      fullPath: "/safety";
      preLoaderRoute: typeof SafetyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/signals": {
      id: "/signals";
      path: "/signals";
      fullPath: "/signals";
      preLoaderRoute: typeof SignalsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/suppliers": {
      id: "/suppliers";
      path: "/suppliers";
      fullPath: "/suppliers";
      preLoaderRoute: typeof SuppliersRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/top5": {
      id: "/top5";
      path: "/top5";
      fullPath: "/top5";
      preLoaderRoute: typeof Top5RouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/demo/": {
      id: "/demo/";
      path: "/";
      fullPath: "/demo/";
      preLoaderRoute: typeof DemoIndexRouteImport;
      parentRoute: typeof DemoRoute;
    };
    "/demo/brief": {
      id: "/demo/brief";
      path: "/brief";
      fullPath: "/demo/brief";
      preLoaderRoute: typeof DemoBriefRouteImport;
      parentRoute: typeof DemoRoute;
    };
    "/demo/claims": {
      id: "/demo/claims";
      path: "/claims";
      fullPath: "/demo/claims";
      preLoaderRoute: typeof DemoClaimsRouteImport;
      parentRoute: typeof DemoRoute;
    };
    "/demo/closed-loop": {
      id: "/demo/closed-loop";
      path: "/closed-loop";
      fullPath: "/demo/closed-loop";
      preLoaderRoute: typeof DemoClosedLoopRouteImport;
      parentRoute: typeof DemoRoute;
    };
    "/demo/compliance": {
      id: "/demo/compliance";
      path: "/compliance";
      fullPath: "/demo/compliance";
      preLoaderRoute: typeof DemoComplianceRouteImport;
      parentRoute: typeof DemoRoute;
    };
    "/demo/dashboard": {
      id: "/demo/dashboard";
      path: "/dashboard";
      fullPath: "/demo/dashboard";
      preLoaderRoute: typeof DemoDashboardRouteImport;
      parentRoute: typeof DemoRoute;
    };
    "/demo/executive": {
      id: "/demo/executive";
      path: "/executive";
      fullPath: "/demo/executive";
      preLoaderRoute: typeof DemoExecutiveRouteImport;
      parentRoute: typeof DemoRoute;
    };
    "/demo/financial": {
      id: "/demo/financial";
      path: "/financial";
      fullPath: "/demo/financial";
      preLoaderRoute: typeof DemoFinancialRouteImport;
      parentRoute: typeof DemoRoute;
    };
    "/demo/open-problem-records": {
      id: "/demo/open-problem-records";
      path: "/open-problem-records";
      fullPath: "/demo/open-problem-records";
      preLoaderRoute: typeof DemoOpenProblemRecordsRouteImport;
      parentRoute: typeof DemoRoute;
    };
    "/demo/portfolio": {
      id: "/demo/portfolio";
      path: "/portfolio";
      fullPath: "/demo/portfolio";
      preLoaderRoute: typeof DemoPortfolioRouteImport;
      parentRoute: typeof DemoRoute;
    };
    "/demo/prevention": {
      id: "/demo/prevention";
      path: "/prevention";
      fullPath: "/demo/prevention";
      preLoaderRoute: typeof DemoPreventionRouteImport;
      parentRoute: typeof DemoRoute;
    };
    "/demo/problem-records": {
      id: "/demo/problem-records";
      path: "/problem-records";
      fullPath: "/demo/problem-records";
      preLoaderRoute: typeof DemoProblemRecordsRouteImport;
      parentRoute: typeof DemoRoute;
    };
    "/demo/programs": {
      id: "/demo/programs";
      path: "/programs";
      fullPath: "/demo/programs";
      preLoaderRoute: typeof DemoProgramsRouteImport;
      parentRoute: typeof DemoRoute;
    };
    "/demo/safety": {
      id: "/demo/safety";
      path: "/safety";
      fullPath: "/demo/safety";
      preLoaderRoute: typeof DemoSafetyRouteImport;
      parentRoute: typeof DemoRoute;
    };
    "/demo/signals": {
      id: "/demo/signals";
      path: "/signals";
      fullPath: "/demo/signals";
      preLoaderRoute: typeof DemoSignalsRouteImport;
      parentRoute: typeof DemoRoute;
    };
    "/demo/suppliers": {
      id: "/demo/suppliers";
      path: "/suppliers";
      fullPath: "/demo/suppliers";
      preLoaderRoute: typeof DemoSuppliersRouteImport;
      parentRoute: typeof DemoRoute;
    };
    "/demo/top5": {
      id: "/demo/top5";
      path: "/top5";
      fullPath: "/demo/top5";
      preLoaderRoute: typeof DemoTop5RouteImport;
      parentRoute: typeof DemoRoute;
    };
    "/demo/users": {
      id: "/demo/users";
      path: "/users";
      fullPath: "/demo/users";
      preLoaderRoute: typeof DemoUsersRouteImport;
      parentRoute: typeof DemoRoute;
    };
    "/problem-record/$id": {
      id: "/problem-record/$id";
      path: "/problem-record/$id";
      fullPath: "/problem-record/$id";
      preLoaderRoute: typeof ProblemRecordIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/demo/problem-record/$id": {
      id: "/demo/problem-record/$id";
      path: "/problem-record/$id";
      fullPath: "/demo/problem-record/$id";
      preLoaderRoute: typeof DemoProblemRecordIdRouteImport;
      parentRoute: typeof DemoRoute;
    };
    "/demo/signal/$id": {
      id: "/demo/signal/$id";
      path: "/signal/$id";
      fullPath: "/demo/signal/$id";
      preLoaderRoute: typeof DemoSignalIdRouteImport;
      parentRoute: typeof DemoRoute;
    };
  }
}

interface DemoRouteChildren {
  DemoBriefRoute: typeof DemoBriefRoute;
  DemoClaimsRoute: typeof DemoClaimsRoute;
  DemoClosedLoopRoute: typeof DemoClosedLoopRoute;
  DemoComplianceRoute: typeof DemoComplianceRoute;
  DemoDashboardRoute: typeof DemoDashboardRoute;
  DemoExecutiveRoute: typeof DemoExecutiveRoute;
  DemoFinancialRoute: typeof DemoFinancialRoute;
  DemoOpenProblemRecordsRoute: typeof DemoOpenProblemRecordsRoute;
  DemoPortfolioRoute: typeof DemoPortfolioRoute;
  DemoPreventionRoute: typeof DemoPreventionRoute;
  DemoProblemRecordsRoute: typeof DemoProblemRecordsRoute;
  DemoProgramsRoute: typeof DemoProgramsRoute;
  DemoSafetyRoute: typeof DemoSafetyRoute;
  DemoSignalsRoute: typeof DemoSignalsRoute;
  DemoSuppliersRoute: typeof DemoSuppliersRoute;
  DemoTop5Route: typeof DemoTop5Route;
  DemoUsersRoute: typeof DemoUsersRoute;
  DemoIndexRoute: typeof DemoIndexRoute;
  DemoProblemRecordIdRoute: typeof DemoProblemRecordIdRoute;
  DemoSignalIdRoute: typeof DemoSignalIdRoute;
}

const DemoRouteChildren: DemoRouteChildren = {
  DemoBriefRoute: DemoBriefRoute,
  DemoClaimsRoute: DemoClaimsRoute,
  DemoClosedLoopRoute: DemoClosedLoopRoute,
  DemoComplianceRoute: DemoComplianceRoute,
  DemoDashboardRoute: DemoDashboardRoute,
  DemoExecutiveRoute: DemoExecutiveRoute,
  DemoFinancialRoute: DemoFinancialRoute,
  DemoOpenProblemRecordsRoute: DemoOpenProblemRecordsRoute,
  DemoPortfolioRoute: DemoPortfolioRoute,
  DemoPreventionRoute: DemoPreventionRoute,
  DemoProblemRecordsRoute: DemoProblemRecordsRoute,
  DemoProgramsRoute: DemoProgramsRoute,
  DemoSafetyRoute: DemoSafetyRoute,
  DemoSignalsRoute: DemoSignalsRoute,
  DemoSuppliersRoute: DemoSuppliersRoute,
  DemoTop5Route: DemoTop5Route,
  DemoUsersRoute: DemoUsersRoute,
  DemoIndexRoute: DemoIndexRoute,
  DemoProblemRecordIdRoute: DemoProblemRecordIdRoute,
  DemoSignalIdRoute: DemoSignalIdRoute,
};

const DemoRouteWithChildren = DemoRoute._addFileChildren(DemoRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BriefRoute: BriefRoute,
  ClaimsRoute: ClaimsRoute,
  ClosedLoopRoute: ClosedLoopRoute,
  ComplianceRoute: ComplianceRoute,
  DashboardRoute: DashboardRoute,
  DataConfidenceRoute: DataConfidenceRoute,
  DemoRoute: DemoRouteWithChildren,
  EffectivenessPreventionRoute: EffectivenessPreventionRoute,
  ExecutiveRoute: ExecutiveRoute,
  FinancialRoute: FinancialRoute,
  FinancialIntelligenceRoute: FinancialIntelligenceRoute,
  PortfolioRoute: PortfolioRoute,
  PreventionRoute: PreventionRoute,
  ProblemRecordsRoute: ProblemRecordsRoute,
  ProfileRoute: ProfileRoute,
  ProgramsRoute: ProgramsRoute,
  RecallSafetyRoute: RecallSafetyRoute,
  SafetyRoute: SafetyRoute,
  SignalsRoute: SignalsRoute,
  SuppliersRoute: SuppliersRoute,
  Top5Route: Top5Route,
  ProblemRecordIdRoute: ProblemRecordIdRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

import type { getRouter } from "./router.tsx";
import type { startInstance } from "./start.ts";

declare module "@tanstack/react-start" {
  interface Register {
    ssr: true;
    router: Awaited<ReturnType<typeof getRouter>>;
    config: Awaited<ReturnType<typeof startInstance.getOptions>>;
  }
}
